import { TextCell } from "./TextCell";

/**
 * Counterparty column cell: the counterparty's name, from a string or an
 * object with `name`, searchable. It renders like `TextCell`; the separate
 * kind keeps sorting, search, and the popover editor alike for every
 * counterparty column.
 */
export const CounterpartyCell = TextCell;
